<template>
  <div class="index-main">
    <Header/>

    <div>
      <div class="section-box">
        <div>
          <div class="section-img">
            <img data-id="1" class="active" src="@/assets/loginBg.png" alt=""/>
            <img class="section-bg" src="@/assets/loginBg.png" alt=""/>
          </div>
          <div class="section-info">
            <div class="login-title">登&nbsp;录</div>
            <div class="login-box">
              <div>
                <label id="user-box" class="info-label" for="user-name">
                  <i class="iconfont icon-yonghu"></i>
                  <input
                    id="user-name"
                    type="text"
                    maxlength="20"
                    v-model="phone"
                    placeholder="请输入手机号"
                  />
                </label>
                <label id="password-box" class="info-label" for="password">
                  <i class="iconfont icon-mima"></i>
                  <input
                    id="password"
                    type="password"
                    v-model="paw"
                    maxlength="20"
                    placeholder="请输入密码"
                    @keyup.enter="login"
                  />
                  <i data-type="1" class="ear iconfont icon-hide"></i>
                </label>
                <div class="login-submit" id="user-login" @click="login">
                  登录
                </div>
                <div class="other">
                  <div>
                    <a
                      href="/forgetPassword"
                      class="forgetPassword"
                    >忘记密码</a
                    >
                    | <a href="/register">用户注册</a>
                  </div>
                </div>
              </div>
            </div>
            <!--<label class="agreement-box" for="user-agreement">-->
            <!--<input id="user-agreement" value="1" type="checkbox">-->
            <!--<div>同意<a href="{:url('/page/user_agreement')}" target="_blank">《用户协议》</a>与<a href="{:url('/page/privacy_policy')}" target="_blank">《隐私政策》</a></div>-->
            <!--</label>-->
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>

import Header from "@/globalComponents/Header";
import Footer from "@/globalComponents/Footer";

export default {
  data() {
    return {
      phone: "",
      paw: ""
    };
  },
  methods: {
    async login() {
      await this.$store.dispatch('user/Login', {
        account: this.phone,
        password: this.paw
      })
      this.$router.push({ "name": "index" })
    }
  },
  components: {
    Header,
    Footer
  }
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue